import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map, catchError } from 'rxjs/operators';
import { domain } from 'src/environments/environment';
import { GlobalProvider } from './global';
import { BaseHelper } from 'src/app/baseHelper';

@Injectable({
  providedIn: 'root',
})
export class PublicService {
  namespace = 'public';
  constructor(private http: HttpClient, private g: GlobalProvider, private b: BaseHelper) {}

  async globalSetting() {
    const url = `${domain}/${this.namespace}/globalSetting`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        throw error;
      })
    );
  }
  async uploadingTest(model) {
    const url = `${domain}/${this.namespace}/uploadingTest`;
    return this.http.post(url, model).pipe(
      map((results) => results),
      catchError((error) => {
        return Promise.resolve({ ok: false });
      })
    );
  }
  async downloadReportExcel(json = {}) {
    const params = json || {};
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/downloadReportExcel`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  getHeader(params = {}) {
    return {
      headers: new HttpHeaders({
        Authorization: this.g.jws,
      }),
      params,
    };
  }
  errorHandle(err) {
    this.b.loadLoading(false);
    let message = err.error ? err.error.message : err.message;
    if (!message) message = err.error ? err.error : 'unknown error';

    this.b.toast(`${err.status}: ${message}`, 5000, `danger`);
  }
}
